
import { StrictMode, useEffect } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { saveUTMParams, trackPageScroll, trackTimeOnPage } from './utils/tracking'

// Сохранение UTM-меток при загрузке страницы
saveUTMParams();

// Отслеживание скролла страницы
let scrollTracked = {
  '25': false,
  '50': false,
  '75': false,
  '100': false
};

window.addEventListener('scroll', () => {
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;
  const scrollTop = window.scrollY;
  const scrollPercentage = Math.round((scrollTop / (documentHeight - windowHeight)) * 100);
  
  if (scrollPercentage >= 25 && !scrollTracked['25']) {
    trackPageScroll(25);
    scrollTracked['25'] = true;
  }
  if (scrollPercentage >= 50 && !scrollTracked['50']) {
    trackPageScroll(50);
    scrollTracked['50'] = true;
  }
  if (scrollPercentage >= 75 && !scrollTracked['75']) {
    trackPageScroll(75);
    scrollTracked['75'] = true;
  }
  if (scrollPercentage >= 100 && !scrollTracked['100']) {
    trackPageScroll(100);
    scrollTracked['100'] = true;
  }
});

// Отслеживание времени на странице
let timeTracked = {
  '30': false,
  '60': false,
  '120': false,
  '300': false
};

let startTime = Date.now();

setInterval(() => {
  const timeOnPage = Math.round((Date.now() - startTime) / 1000);
  
  if (timeOnPage >= 30 && !timeTracked['30']) {
    trackTimeOnPage(30);
    timeTracked['30'] = true;
  }
  if (timeOnPage >= 60 && !timeTracked['60']) {
    trackTimeOnPage(60);
    timeTracked['60'] = true;
  }
  if (timeOnPage >= 120 && !timeTracked['120']) {
    trackTimeOnPage(120);
    timeTracked['120'] = true;
  }
  if (timeOnPage >= 300 && !timeTracked['300']) {
    trackTimeOnPage(300);
    timeTracked['300'] = true;
  }
}, 1000);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
